<template>
  <footer class="footer">
    <div class='container'>
      <div class="footer__wrapper">
        <div class="footer__inner">
          <div class="footer__topline topline-footer">
            <nav class="topline-footer__nav">
              <ul class="topline-footer__list">
                <li><router-link to="/how-it-works" class="topline-footer__link">О нас</router-link></li>
                <li><router-link to="/kak-reshit-bez-urista" class="topline-footer__link">Как разобраться во всем самому?</router-link></li>
                <li><router-link to="/contacts" class="topline-footer__link">Контакты</router-link></li>
                <li style="visibility: hidden"><router-link to="#" class="topline-footer__link">Вопрос-ответ</router-link></li>
                <li style="visibility: hidden"><router-link to="#" class="topline-footer__link">Публикации</router-link></li>
                <li style="visibility: hidden"><router-link to="#" class="topline-footer__link">Документы для возврата прав</router-link></li>
              </ul>
            </nav>
            <div class="topline-footer__info info-topline">
              <ul class="info-topline">
                <li v-for="group in groups" :key="group.id"><router-link :to="'/groups/' + group.id" class="info-topline__link">{{group.name}}</router-link></li>
              </ul>
            </div>
          </div>
          <div class="footer__info">
            <div class="footer__method">
              <img src="/static/img/footer/visa.svg" alt="" />
              <img src="/static/img/footer/mastercard.svg" alt="" />
              <img src="/static/img/footer/mir.svg" alt="" />
            </div>
            <a href="tel:88002010339" class="footer__phone">8 800 201 0339</a>
            <a href="mailto:a@moi-uristy.ru" class="footer__email">a@moi-uristy.ru</a>
            <div class="footer__social">
              <a href="https://www.facebook.com/antiurist/" class="social__link social__link--vk">
                <img src="/static/img/footer/fb.svg" alt="" />
              </a>
              <a href="https://vk.com/public198217643" class="social__link social__link--fb">
                <img src="/static/img/footer/vk.svg" alt="" />
              </a>
            </div>
          </div>
        </div>
        <div class="footer__title">
          <p>НО АНО Первое Арбитражное Учреждение</p>
          <span>ИНН 6163149544</span>
          <span>ОГРН 1166100052128</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'footer',
  data () {
    return {
      groups: []
    }
  },
  mounted () {
    axios.get('https://bez.v-avtoservice.com/list/get-lists?id=38').then(response => {
      this.groups = response.data
    })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/include/footer.vue